module.exports = __webpack_public_path__ + "static/media/googleAssistant.c24ba791.svg";